var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "wp-10 p-2 br mb-0 gray-0-bkg flex-row",
          staticStyle: { "justify-content": "space-between" }
        },
        [
          _c("el-input", {
            ref: "search-input",
            staticClass: "w-4",
            attrs: {
              placeholder: _vm.placeholder,
              suffixIcon: "icon-search black pl-2"
            },
            nativeOn: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.process()
              }
            },
            model: {
              value: _vm.searchTxt,
              callback: function($$v) {
                _vm.searchTxt = $$v
              },
              expression: "searchTxt"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "label-number" }, [
            _vm._v(
              _vm._s(_vm.getFilterData.length) +
                " " +
                _vm._s(_vm.rowNumberLabel)
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "table-simple-list",
          staticStyle: { height: "calc(100% - 240px)", overflow: "auto" },
          attrs: {
            id: "simple-list-table",
            data: _vm.getFilterData,
            defaultSort: { prop: _vm.columns[0].name, order: "ascending" }
          }
        },
        _vm._l(_vm.columns, function(column, index) {
          return _c("el-table-column", {
            key: index,
            attrs: {
              prop: column.name,
              label: column.label,
              width: column.width,
              sortable: column.sortable
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "router-link",
                        {
                          staticClass: "flex-row wp-10 simple-list-row",
                          class: "" + (column.isLink ? "row-link" : ""),
                          attrs: {
                            to: _vm.getRowLink(scope.row),
                            target: "_blank"
                          }
                        },
                        [
                          column.name === "name"
                            ? _c(
                                "icon-svg",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    iconName: _vm.field,
                                    width: 32,
                                    height: 32,
                                    viewBox: "0 0 32 32"
                                  }
                                },
                                [_c("icon-" + _vm.field, { tag: "component" })],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !column.isDate
                            ? _c(
                                "span",
                                { staticStyle: { "align-self": "center" } },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(scope.row[column.name]) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          column.isDate
                            ? _c(
                                "span",
                                { staticStyle: { "align-self": "center" } },
                                [
                                  scope.row[column.name]
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm._f("dateFormatter")(
                                                scope.row[column.name],
                                                "DASHED_DATE",
                                                false
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }